import { TFunction, TFunctionResult } from 'i18next';
import { Notification, NotificationVariant } from 'src/js/notification/notification';
import { constant } from 'src/js/constant';

// createAndDispatchNotification() can be used publicly by components
export const createAndDispatchNotification = (
  message: string | TFunctionResult, // | number,
  type: NotificationVariant,
  t?: TFunction,
  options?: {
    autohide?: boolean;
    dismissible?: boolean;
    clearPrevious?: boolean;
    link?: string;
    url?: string;
  },
  title?: string,
) => {
  if (message) {
    document.dispatchEvent(
      new CustomEvent<Notification>(constant.addMessageEvent, {
        detail: {
          message: message ?? t?.(`notifications.messages.${type}`),
          title: title,
          variant: type,
          prefix: t?.(`notifications.prefixes.${type}`),
          autohide: options?.autohide,
          dismissible: options?.dismissible,
          clearPrevious: options?.clearPrevious,
        },
      }),
    );
  }
};

// clearAllPermanentNotifications() can be used publicly by components
export const clearAllPermanentNotifications = () => {
  document.dispatchEvent(new CustomEvent(constant.clearAllPermanentNotificationEvent, { detail: {} }));
};

// clearAllNotifications() can be used publicly by components
export const clearAllNotifications = () => {
  document.dispatchEvent(new CustomEvent(constant.clearAllNotificationEvent, { detail: {} }));
};
